import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	container: {
		marginTop: theme.spacing(3),
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(2)
		}
	}
}));
